"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configurationChangeReducer = configurationChangeReducer;
exports["default"] = combinedDesignAreaReducer;
exports.designAreaReducer = designAreaReducer;
var _get = _interopRequireDefault(require("lodash/get"));
var _find = _interopRequireDefault(require("lodash/find"));
var configuratorActionTypes = _interopRequireWildcard(require("../Configurator/Actions"));
var _Actions2 = require("./Actions");
var _Transformers = require("./Transformers");
var _Selectors = require("./Selectors");
var _Selectors2 = require("../Configurator/Selectors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  filteredDesignAreas: [],
  selectedDesignArea: {},
  previousEditedDesignArea: {},
  initialCanvasPosition: [],
  showHighlight: true
};
function designAreaReducer(state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case configuratorActionTypes.RECEIVE_DESIGNER_DATA:
      {
        var data = action.data,
          globalState = action.globalState;
        var nextState = _objectSpread(_objectSpread({}, state), (0, _Transformers.processConfigurationModes)(data));
        return (0, _Transformers.recalculateDesignAreas)(nextState, getDesignProductionMethodMap(globalState, nextState.filteredDesignAreas), (0, _Selectors2.visualizationModeCheck)(globalState));
      }
    case _Actions2.actionTypes.SELECT_DESIGN_AREA:
      {
        var designAreaIdentifier = action.designAreaIdentifier;
        var designArea = (0, _find["default"])(state.filteredDesignAreas, {
          identifier: designAreaIdentifier
        });
        if (!designArea) {
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedDesignArea: designArea,
          showHighlight: false
        });
      }
    case _Actions2.actionTypes.SET_PREVIOUS_EDITED_DESIGN_AREA:
      {
        var _designAreaIdentifier = action.designAreaIdentifier;
        var _designArea = (0, _find["default"])(state.filteredDesignAreas, {
          identifier: _designAreaIdentifier
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          previousEditedDesignArea: _designArea
        });
      }
    case _Actions2.actionTypes.CLEAR_DESIGN_AREA_SELECTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedDesignArea: {},
          lastSelectedDesignAreaIdentifier: (0, _get["default"])(state, 'selectedDesignArea.identifier', ''),
          showHighlight: true
        });
      }
    case _Actions2.actionTypes.TOGGLE_HIGHLIGHT:
      {
        var showHighlight = action.showHighlight;
        return _objectSpread(_objectSpread({}, state), {}, {
          showHighlight: showHighlight
        });
      }
    case _Actions2.actionTypes.RECALCULATE_DESIGN_AREA:
      {
        var _globalState = action.globalState;
        return (0, _Transformers.recalculateDesignAreas)(state, getDesignProductionMethodMap(_globalState, state.filteredDesignAreas), (0, _Selectors2.visualizationModeCheck)(_globalState));
      }
  }
  return state;
}
function getDesignProductionMethodMap(globalState, designAreas) {
  return designAreas.reduce(function (designProductionMethodMap, designArea) {
    return _objectSpread(_objectSpread({}, designProductionMethodMap), {}, _defineProperty({}, designArea.identifier, (0, _Selectors.getSelectedDesignProductionMethodForDesignArea)(globalState, designArea)));
  }, {});
}
function configurationChangeReducer(state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case configuratorActionTypes.RECEIVE_CONFIGURATION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          // clean up data if a new configuration comes (it fetches its own designer data anyway)
          // this also triggers the removal of current canvases leading to a fresh init of the new ones
          filteredDesignAreas: [],
          selectedDesignArea: {},
          previousEditedDesignArea: {},
          initialCanvasPosition: []
        });
      }
    default:
      return state;
  }
}
function combinedDesignAreaReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return [designAreaReducer, configurationChangeReducer].reduce(function (state, reducerFn) {
    return reducerFn(state, action);
  }, state);
}